import React, {Component} from 'react'

class Gel extends Component{
    render(){
        const {width} = this.props
        return(
            <svg id="Layer_1" width={width} data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 169.06 198.43">
            <path  d="M162.3,91a85.88,85.88,0,0,1,10.63.66V76.86L187.1,62.68v32a85.15,85.15,0,0,1,59.22,68.21l-13.16,13.16a70.89,70.89,0,0,0-46.06-66.4V161.9l-14.17,14.17V106a71.58,71.58,0,0,0-21.26,0v55.9l-14.17,14.17v-66.4a70.88,70.88,0,0,0,24.8,137.27h70.87L219,261.11H77.26l14.17-14.17h23.85A85.06,85.06,0,0,1,137.49,94.71V76.86l14.17-14.17v29A85.86,85.86,0,0,1,162.3,91Z" transform="translate(-77.26 -62.68)"/></svg>        )
    }    
}

export default Gel


// WEBPACK FOOTER //
// ./src/components/Svgs/Gel.js